import React, { useState, useEffect } from 'react';

const HistoryContent = () => {
  const [auditLogs, setAuditLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [filters, setFilters] = useState({
    user: '',
    action: '',
    page: '',
    dateRange: ''
  });

  // Mock data - replace with actual API call
  useEffect(() => {
    const mockLogs = [
      {
        id: 1,
        user: 'Reza Andreawan',
        email: 'reza.andreawan@jago.com',
        action: 'Upload File',
        page: 'PDF Parser Smart',
        pageId: 'smart-parser',
        timestamp: new Date('2025-01-15T10:30:00'),
        details: 'Uploaded bank_statement.pdf'
      },
      {
        id: 2,
        user: 'Reza Andreawan',
        email: 'reza.andreawan@jago.com',
        action: 'Export Data',
        page: 'Financial Analysis',
        pageId: 'financial-analysis',
        timestamp: new Date('2025-01-15T09:15:00'),
        details: 'Exported analysis_results.xlsx'
      },
      {
        id: 3,
        user: 'Reza Andreawan',
        email: 'reza.andreawan@jago.com',
        action: 'View Results',
        page: 'Audit Plan Analysis',
        pageId: 'audit-plan-analysis',
        timestamp: new Date('2025-01-15T08:45:00'),
        details: 'Viewed audit plan results'
      },
      {
        id: 4,
        user: 'Reza Andreawan',
        email: 'reza.andreawan@jago.com',
        action: 'Process File',
        page: 'PDF Parser Smart',
        pageId: 'smart-parser',
        timestamp: new Date('2025-01-14T16:20:00'),
        details: 'Processed statement_2024.pdf'
      },
      {
        id: 5,
        user: 'Reza Andreawan',
        email: 'reza.andreawan@jago.com',
        action: 'Update Settings',
        page: 'LLM Configuration',
        pageId: 'llm-config',
        timestamp: new Date('2025-01-14T14:10:00'),
        details: 'Updated API key for OpenAI'
      },
      {
        id: 6,
        user: 'Reza Andreawan',
        email: 'reza.andreawan@jago.com',
        action: 'Generate Insights',
        page: 'Financial Analysis',
        pageId: 'financial-analysis',
        timestamp: new Date('2025-01-14T11:30:00'),
        details: 'Generated AI insights for Q4 2024'
      },
      {
        id: 7,
        user: 'Reza Andreawan',
        email: 'reza.andreawan@jago.com',
        action: 'Download Report',
        page: 'Audit Plan Analysis',
        pageId: 'audit-plan-analysis',
        timestamp: new Date('2025-01-13T15:45:00'),
        details: 'Downloaded audit_report.xlsx'
      },
      {
        id: 8,
        user: 'Reza Andreawan',
        email: 'reza.andreawan@jago.com',
        action: 'Upload File',
        page: 'RnD Prompting',
        pageId: 'rnd-prompting',
        timestamp: new Date('2025-01-13T13:20:00'),
        details: 'Uploaded test_document.pdf'
      }
    ];
    setAuditLogs(mockLogs);
    setFilteredLogs(mockLogs);
  }, []);

  const getActionIcon = (action) => {
    switch (action) {
      case 'Upload File':
        return 'fa-upload';
      case 'Export Data':
      case 'Download Report':
        return 'fa-download';
      case 'View Results':
        return 'fa-eye';
      case 'Process File':
        return 'fa-gear';
      case 'Update Settings':
        return 'fa-cog';
      case 'Generate Insights':
        return 'fa-brain';
      default:
        return 'fa-circle';
    }
  };

  const getActionColor = (action) => {
    switch (action) {
      case 'Upload File':
        return 'text-blue-600 bg-blue-50';
      case 'Export Data':
      case 'Download Report':
        return 'text-green-600 bg-green-50';
      case 'View Results':
        return 'text-purple-600 bg-purple-50';
      case 'Process File':
        return 'text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-900/30';
      case 'Update Settings':
        return 'text-gray-600 dark:text-gray-300 bg-gray-50 dark:bg-gray-700';
      case 'Generate Insights':
        return 'text-indigo-600 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-900/30';
      default:
        return 'text-gray-600 dark:text-gray-300 bg-gray-50 dark:bg-gray-700';
    }
  };

  const formatDate = (date) => {
    const now = new Date();
    const diff = now - date;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    if (hours < 24) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    if (days < 7) return `${days} day${days > 1 ? 's' : ''} ago`;
    
    return date.toLocaleDateString('id-ID', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    
    let filtered = [...auditLogs];
    
    if (newFilters.user) {
      filtered = filtered.filter(log => 
        log.user.toLowerCase().includes(newFilters.user.toLowerCase()) ||
        log.email.toLowerCase().includes(newFilters.user.toLowerCase())
      );
    }
    
    if (newFilters.action) {
      filtered = filtered.filter(log => 
        log.action.toLowerCase().includes(newFilters.action.toLowerCase())
      );
    }
    
    if (newFilters.page) {
      filtered = filtered.filter(log => 
        log.page.toLowerCase().includes(newFilters.page.toLowerCase())
      );
    }
    
    if (newFilters.dateRange) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const daysAgo = parseInt(newFilters.dateRange);
      const startDate = new Date(today);
      startDate.setDate(startDate.getDate() - daysAgo);
      
      filtered = filtered.filter(log => log.timestamp >= startDate);
    }
    
    setFilteredLogs(filtered);
  };

  const uniqueUsers = [...new Set(auditLogs.map(log => log.user))];
  const uniqueActions = [...new Set(auditLogs.map(log => log.action))];
  const uniquePages = [...new Set(auditLogs.map(log => log.page))];

  return (
    <main className="p-6">
      <div className="w-full">
        {/* Header */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm dark:shadow-gray-900/50 p-6 mb-6 transition-colors duration-300">
          <h1 className="text-2xl font-bold text-gray-800 dark:text-white mb-2 flex items-center transition-colors duration-300">
            <i className="fa-solid fa-clock-rotate-left mr-3 text-blue-600 dark:text-blue-400"></i>
            Audit Log History
          </h1>
          <p className="text-gray-600 dark:text-gray-300 text-sm transition-colors duration-300">
            Track all user activities and system events across the platform
          </p>
        </div>

        {/* Filters */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm dark:shadow-gray-900/50 p-4 mb-6 transition-colors duration-300">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div>
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1 transition-colors duration-300">
                User
              </label>
              <input
                type="text"
                placeholder="Search user..."
                value={filters.user}
                onChange={(e) => handleFilterChange('user', e.target.value)}
                className="w-full px-3 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg text-sm text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors duration-300"
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1 transition-colors duration-300">
                Action
              </label>
              <select
                value={filters.action}
                onChange={(e) => handleFilterChange('action', e.target.value)}
                className="w-full px-3 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg text-sm text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors duration-300"
              >
                <option value="">All Actions</option>
                {uniqueActions.map(action => (
                  <option key={action} value={action}>{action}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1 transition-colors duration-300">
                Page
              </label>
              <select
                value={filters.page}
                onChange={(e) => handleFilterChange('page', e.target.value)}
                className="w-full px-3 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg text-sm text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors duration-300"
              >
                <option value="">All Pages</option>
                {uniquePages.map(page => (
                  <option key={page} value={page}>{page}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1 transition-colors duration-300">
                Date Range
              </label>
              <select
                value={filters.dateRange}
                onChange={(e) => handleFilterChange('dateRange', e.target.value)}
                className="w-full px-3 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg text-sm text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors duration-300"
              >
                <option value="">All Time</option>
                <option value="1">Last 24 Hours</option>
                <option value="7">Last 7 Days</option>
                <option value="30">Last 30 Days</option>
                <option value="90">Last 90 Days</option>
              </select>
            </div>
          </div>
        </div>

        {/* Audit Log Table */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm dark:shadow-gray-900/50 overflow-hidden transition-colors duration-300">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600 transition-colors duration-300">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider transition-colors duration-300">
                    User
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider transition-colors duration-300">
                    Action
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider transition-colors duration-300">
                    Page
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider transition-colors duration-300">
                    Details
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider transition-colors duration-300">
                    Timestamp
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700 transition-colors duration-300">
                {filteredLogs.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="px-6 py-8 text-center text-gray-500 dark:text-gray-400 transition-colors duration-300">
                      <i className="fa-solid fa-inbox text-4xl mb-2 block"></i>
                      No audit logs found
                    </td>
                  </tr>
                ) : (
                  filteredLogs.map((log) => (
                    <tr key={log.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 h-8 w-8 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center transition-colors duration-300">
                            <span className="text-blue-600 dark:text-blue-400 text-xs font-medium transition-colors duration-300">
                              {log.user.charAt(0)}
                            </span>
                          </div>
                          <div className="ml-3">
                            <div className="text-sm font-medium text-gray-900 dark:text-white transition-colors duration-300">
                              {log.user}
                            </div>
                            <div className="text-xs text-gray-500 dark:text-gray-400 transition-colors duration-300">
                              {log.email}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium transition-colors duration-300 ${getActionColor(log.action)}`}>
                          <i className={`fa-solid ${getActionIcon(log.action)} mr-1.5`}></i>
                          {log.action}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900 dark:text-white transition-colors duration-300">{log.page}</div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-sm text-gray-600 dark:text-gray-300 transition-colors duration-300">{log.details}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-500 dark:text-gray-400 transition-colors duration-300">
                          {formatDate(log.timestamp)}
                        </div>
                        <div className="text-xs text-gray-400 dark:text-gray-500 mt-1 transition-colors duration-300">
                          {log.timestamp.toLocaleString('id-ID', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Summary */}
          {filteredLogs.length > 0 && (
            <div className="bg-gray-50 dark:bg-gray-700/50 px-6 py-3 border-t border-gray-200 dark:border-gray-700 transition-colors duration-300">
              <div className="flex items-center justify-between text-sm text-gray-600 dark:text-gray-300 transition-colors duration-300">
                <span>
                  Showing <strong className="text-gray-800 dark:text-white">{filteredLogs.length}</strong> of <strong className="text-gray-800 dark:text-white">{auditLogs.length}</strong> audit logs
                </span>
                <button className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 font-medium transition-colors duration-200">
                  <i className="fa-solid fa-download mr-1"></i>
                  Export Logs
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default HistoryContent;

